import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from '../../../app.definitions';
import { Observable } from 'rxjs';
import { ApiResponse, UserListItem } from '../../../shared/models';
import { CreateAndAddToSubmissionRequest } from '../../../shared/models/developer-mode/create-and-add-submission-request.model';
import { CreateAndAddToSubmissionResponse } from '../../../shared/models/developer-mode/create-and-add-submission-response.model';
import { CreateWeightEntryRequest } from '../../../shared/models/developer-mode/create-weight-entry-request.model';
import { ConnectionTypes } from '../../../shared/models/developer-mode/connection-types.model';

@Injectable({
  providedIn: 'root',
})
export class DeveloperService {
  constructor(@Inject(API_BASE_URL) private apiBaseUrl: string, private httpClient: HttpClient) {}

  public createAndAddToSubmission(
    request: CreateAndAddToSubmissionRequest
  ): Observable<ApiResponse<CreateAndAddToSubmissionResponse>> {
    return this.httpClient.post<ApiResponse<CreateAndAddToSubmissionResponse>>(
      `${this.apiBaseUrl}/users/${request.userId}/submissions/createAndAddToSubmission`,
      request
    );
  }

  public createWeightEntry(request: CreateWeightEntryRequest): Observable<void> {
    return this.httpClient.post<void>(
      `${this.apiBaseUrl}/users/${request.userId}/weight-data/history`,
      request
    );
  }

  public triggerUserMail(
    sendEmailToUserId: string,
    mailType: string,
    requestedByUserId: string
  ): Observable<void> {
    return this.httpClient.post<void>(
      `${this.apiBaseUrl}/monitoring/${requestedByUserId}/trigger-mail`,
      {
        sendEmailToUserId,
        requestedByUserId,
        mailType,
      }
    );
  }

  public connectUsers(
    connectionType: ConnectionTypes,
    sourceUserId: string,
    targetEmail: string
  ): Observable<ApiResponse<UserListItem>> {
    return this.httpClient.post<ApiResponse<UserListItem>>(
      `${this.apiBaseUrl}/monitoring/${sourceUserId}/connect`,
      { sourceUserId, targetEmail, connectionType }
    );
  }

  public removeUserConnection(
    connectionType: ConnectionTypes,
    sourceUserId: string,
    targetUserId: string
  ): Observable<void> {
    return this.httpClient.post<void>(
      `${this.apiBaseUrl}/monitoring/${sourceUserId}/disconnect`,
      { connectionType, sourceUserId, targetUserId }
    );
  }

}
